import { render, staticRenderFns } from "./HeaderMenuMobile.vue?vue&type=template&id=55d548f9&scoped=true&"
import script from "./HeaderMenuMobile.vue?vue&type=script&lang=js&"
export * from "./HeaderMenuMobile.vue?vue&type=script&lang=js&"
import style0 from "./HeaderMenuMobile.vue?vue&type=style&index=0&id=55d548f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d548f9",
  null
  
)

export default component.exports